import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/control-label.module.css';

interface ControlLabelTypographyProps extends TypographyProps {
    htmlFor?: string;
    [key: string]: unknown;
}

function ControlLabelTypography({ className = null, ...props }: ControlLabelTypographyProps) {
    return (
        <Typography tag="label" className={classNames([styles.container, className])} {...props} />
    );
}

export default ControlLabelTypography;
